import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Network } from "lucide-react";

export default function PolityRadialMindMapsPage() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-[100dvh] bg-slate-50" data-testid="polity-radial-mindmaps-page">
      {/* Top bar */}
      <div className="sticky top-0 z-10 flex items-center gap-3 bg-white border-b border-slate-200 px-4 py-3">
        <button
          type="button"
          onClick={() => navigate("/prelims/master/polity")}
          data-testid="radial-back-btn"
          className="inline-flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" /> Back
        </button>
        <div className="h-4 w-px bg-slate-200" />
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
          <Network className="w-4 h-4 text-amber-600" />
          Polity Radial Mind Maps
        </div>
      </div>

      {/* Embedded viewer — leave room for the global bottom nav */}
      <iframe
        src="/polity-radial-mindmaps.html"
        title="Polity Radial Mind Maps"
        data-testid="radial-mindmaps-iframe"
        className="flex-1 w-full border-0 mb-16"
      />
    </div>
  );
}
